(function (TIPTOE, window, document, $) {
  /** @type {Function} Custom logger */
  const log = TIPTOE.HAS_DEBUG ? window.console.log.bind(window, 'ADD TO CART:') : function () {};

  /**
   * AddToCart Class
   */
  function AddToCart() {
    this.onAddedToCart = this.onAddedToCart.bind(this);

    $(document.body).on('added_to_cart', this.onAddedToCart);

    return this;
  }

  AddToCart.prototype.sendGA = function () {
    if (typeof window.ga !== 'function') {
      return false;
    }

    ga('send', 'event', 'Intention_Achat', 'Produit_Ajoute_Au_Panier', 'Produit_Ajoute_Au_Panier', {
      hitCallback() {
        console.log(
          'analytics.js done sending data /// event: Intention_D_Achat, Produit_Ajoute_Au_Panier, Produit_Ajoute_Au_Panier',
        );
      },
    });
  };

  AddToCart.prototype.sendDatalayer = function (item) {
    if (!window.dataLayer || typeof window.dataLayer.push !== 'function') {
      return false;
    }

    window.dataLayer.push(item);
  };

  /**
   * On added to cart.
   */
  AddToCart.prototype.onAddedToCart = function (event, fragments, cart_hash, $button) {
    this.sendGA();

    if (fragments.datalayer_addToCart) {
      this.sendDatalayer(fragments.datalayer_addToCart);
    }

    if (fragments.datalayer_add_to_cart) {
      this.sendDatalayer(fragments.datalayer_add_to_cart);
    }
  };

  new AddToCart();
})(TIPTOE, window, document, jQuery);
